import { Formik } from "formik";
import React, { Component } from "react";
import Swal from "sweetalert2";
import InputCustom from "../../components/InputCustom";
import Button from "../../components/Button";
import * as equipe from "../../crud/equipe.crud";
import { validarFormulario } from "./EquipeUtils";
import styles from "../../styles/Equipe.module.scss";
import Breadcrumb from "../../components/Breadcrumb";
import CheckboxCustom from "../../components/CheckboxCustom";

const valores_iniciais = {
    email: "",
    usr_nome: "",
    usr_pode_solicitar_viagens: false,
    usr_possui_acesso_painel: false,
};

export default class EquipeNew extends Component {
    state = {
        loading: false,
    };

    handleAdicionarMembro = (values, setErrors) => {
        const erros = validarFormulario(values);

        if (Object.keys(erros).length > 0) {
            setErrors(erros);

            const primeira_mensagem = Object.values(erros)[0];

            Swal.fire("Ops!", primeira_mensagem, "warning");

            return;
        }

        this.setState({ loading: true });

        equipe.create({
            email: values.email,
            usr_nome: values.usr_nome,
            usr_pode_solicitar_viagens: values.usr_pode_solicitar_viagens,
            usr_possui_acesso_painel: values.usr_possui_acesso_painel,
        })
            .then(() => {
                this.props.history.push("/equipe");
            })
            .catch((err) => {
                const errors_api = err.response?.data?.errors;
                const msg_email = errors_api?.email?.[0];

                if (msg_email) {
                    setErrors({ email: msg_email });
                }

                const msg = msg_email || errors_api?.[0] || "Erro ao salvar. Tente novamente.";

                Swal.fire("Ops!", msg, "error");
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    render() {
        const { loading } = this.state;

        return (
            <div className={styles.container}>
                <Breadcrumb paiTo="/equipe" paiLabel="Equipe" atual="Novo membro" />

                <Formik initialValues={valores_iniciais} onSubmit={() => {}}>
                    {({ values, setFieldValue, setErrors, handleBlur, touched, errors }) => (
                        <>
                            <div className={styles.card}>
                                <div className={styles.secao}>
                                    <p className={styles.secaoTitulo}>Dados gerais</p>
                                    <p className={styles.secaoDescricao}>Informe um e-mail para localizar ou cadastrar um novo membro.</p>

                                    <div className={styles.gridDuasColunas}>
                                        <InputCustom
                                            label="E-mail"
                                            name="email"
                                            type="email"
                                            value={values.email}
                                            onChange={(e) => setFieldValue("email", e.target.value)}
                                            onBlur={handleBlur}
                                            disabled={loading}
                                            required
                                            errors={errors}
                                            touched={touched}
                                        />

                                        <InputCustom
                                            label="Nome"
                                            name="usr_nome"
                                            type="text"
                                            value={values.usr_nome}
                                            onChange={(e) => setFieldValue("usr_nome", e.target.value)}
                                            onBlur={handleBlur}
                                            disabled={loading}
                                            required
                                            errors={errors}
                                            touched={touched}
                                        />
                                    </div>
                                </div>

                                <span className={styles.divisor} />

                                <div className={styles.secao}>
                                    <p className={styles.secaoTitulo}>Permissões</p>
                                    <p className={styles.secaoDescricao}>Defina o nível de permissões que o membro deve possuir.</p>

                                    <div className={styles.permissoesGrid}>
                                        <CheckboxCustom
                                            label="Permitir solicitação de viagens em nome da empresa"
                                            checked={values.usr_pode_solicitar_viagens}
                                            onChange={(e) => setFieldValue("usr_pode_solicitar_viagens", e.target.checked)}
                                            disabled={loading}
                                        />

                                        <CheckboxCustom
                                            label="Permitir acesso ao painel da empresa"
                                            checked={values.usr_possui_acesso_painel}
                                            onChange={(e) => setFieldValue("usr_possui_acesso_painel", e.target.checked)}
                                            disabled={loading}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={styles.botoesRodape}>
                                <Button
                                    type="button"
                                    variant="default"
                                    outlined
                                    size="md"
                                    disabled={loading}
                                    onClick={() => this.props.history.push("/equipe")}
                                >
                                    Cancelar
                                </Button>

                                <Button
                                    type="button"
                                    variant="primary"
                                    size="md"
                                    loading={loading}
                                    disabled={loading}
                                    onClick={() => this.handleAdicionarMembro(values, setErrors)}
                                >
                                    Adicionar membro
                                </Button>
                            </div>
                        </>
                    )}
                </Formik>
            </div>
        );
    }
}
